import Vue from "vue";
import Router from "vue-router";
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};
Vue.use(Router);

export default new Router({
  mode: "hash",
  routes: [
    {
      path: "/",
      name: "Home",
      component: resolve => require(["@/Views/Home"], resolve),
      meta: {
        title: "首页",
        roles: [],
        requireAuth: false
      }
    },
    {
      path: "/consulting",
      name: "Consulting",
      redirect: "/consulting/info",
      component: resolve => require(["@/Views/Consulting"], resolve),
      meta: {
        title: "前沿资讯",
        roles: [],
        requireAuth: false
      },
      children: [
        {
          path: "/consulting/info",
          name: "Information",
          component: resolve =>
            require(["@/Views/Consulting/Information"], resolve),
          meta: {
            title: "前沿资讯",
            roles: [],
            requireAuth: false
          }
        },
        {
          path: "/consulting/detail/:id/:m_type",
          name: "ConsultingInfoDetail",
          component: resolve => require(["@/Views/InfoDetail"], resolve),
          meta: {
            title: "前沿资讯-详情",
            roles: [],
            requireAuth: false
          }
        }
      ]
    },
    {
      path: "/product",
      name: "Product",
      redirect: "/product/show",
      component: resolve => require(["@/Views/Product"], resolve),
      meta: {
        title: "产品展销",
        roles: [],
        requireAuth: false
      },
      children: [
        {
          path: "/product/show",
          name: "ProductShow",
          component: resolve => require(["@/Views/Product/Online"], resolve),
          meta: {
            title: "线上展会",
            roles: [],
            requireAuth: false
          }
        },
        {
          path: "/product/base",
          name: "ProductBase",
          component: resolve => require(["@/Views/Product/Base"], resolve),
          meta: {
            title: "线上展会",
            roles: [],
            requireAuth: false
          }
        },
        {
          path: "/product/detail/:id/:m_type",
          name: "ProductInfoDetail",
          component: resolve =>
            require(["@/Views/InfoDetail/ProductShowDetail"], resolve),
          meta: {
            title: "线上展会-详情",
            roles: [],
            requireAuth: false
          }
        },
        {
          path: "/product/product-detail/:id/:m_type",
          name: "ProductInfoDetail",
          component: resolve => require(["@/Views/InfoDetail"], resolve),
          meta: {
            title: "产品基地-详情",
            roles: [],
            requireAuth: false
          }
        }
      ]
    },
    {
      path: "/policy",
      name: "Policy",
      redirect: "/policy/declare",
      component: resolve => require(["@/Views/Policy"], resolve),
      meta: {
        title: "政策申报",
        roles: [],
        requireAuth: false
      },
      children: [
        {
          path: "/policy/declare",
          name: "PolicyDeclare",
          component: resolve => require(["@/Views/Policy/Declare"], resolve),
          meta: {
            title: "项目申报",
            roles: [],
            requireAuth: false
          }
        },
        {
          path: "/policy/explain",
          name: "PolicyExplain",
          component: resolve => require(["@/Views/Policy/Explain"], resolve),
          meta: {
            title: "政策解读",
            roles: [],
            requireAuth: false
          }
        },
        {
          path: "/policy/declare-detail/:id/:m_type",
          name: "DeclareDetail",
          component: resolve =>
            require(["@/Views/InfoDetail/DeclareDetail"], resolve),
          meta: {
            title: "项目申报-详情",
            roles: [],
            requireAuth: false
          }
        },
        {
          path: "/policy/explain-detail/:id/:is_project",
          name: "PolicyInfoDetail",
          component: resolve =>
            require(["@/Views/InfoDetail/PolicyDetail"], resolve),
          meta: {
            title: "政策解读-详情",
            roles: [],
            requireAuth: false
          }
        }
      ]
    },
    {
      path: "/share-lab",
      name: "ShareLab",
      redirect: "/share-lab/files",
      component: resolve => require(["@/Views/ShareLab"], resolve),
      meta: {
        title: "共享实验室",
        roles: [],
        requireAuth: false
      },
      children: [
        {
          path: "/share-lab/info",
          name: "Information",
          component: resolve =>
            require(["@/Views/ShareLab/Information"], resolve),
          meta: {
            title: "前沿资讯",
            roles: [],
            requireAuth: false
          }
        },
        {
          path: "/share-lab/files",
          name: "Files",
          component: resolve => require(["@/Views/ShareLab/Files"], resolve),
          meta: {
            title: "质量文件",
            roles: [],
            requireAuth: false
          }
        },
        {
          path: "/share-lab/lab",
          name: "Lab",
          component: resolve => require(["@/Views/ShareLab/Lab"], resolve),
          meta: {
            title: "实验室资源",
            roles: [],
            requireAuth: false
          }
        },
        {
          path: "/share-lab/detail/:id/:m_type",
          name: "ShareLabInfoDetail",
          component: resolve => require(["@/Views/InfoDetail"], resolve),
          meta: {
            title: "共享实验室平台-详情",
            roles: [],
            requireAuth: false
          }
        }
      ]
    },
    {
      path: "/material-collection",
      name: "MaterialCollection",
      redirect: "/material-collection/requirement",
      component: resolve => require(["@/Views/MaterialCollection"], resolve),
      meta: {
        title: "原料集采平台",
        roles: [],
        requireAuth: false
      },
      children: [
        {
          path: "/material-collection/base",
          name: "Base",
          component: resolve =>
            require(["@/Views/MaterialCollection/Base"], resolve),
          meta: {
            title: "产品基地",
            roles: [],
            requireAuth: false
          }
        },
        {
          path: "/material-collection/requirement",
          name: "Requirement",
          component: resolve =>
            require(["@/Views/MaterialCollection/Requirement"], resolve),
          meta: {
            title: "物资需求",
            roles: [],
            requireAuth: false
          }
        },
        {
          path: "/material-collection/detail/:id/:m_type",
          name: "MaterialCollectionInfoDetail",
          component: resolve => require(["@/Views/InfoDetail"], resolve),
          meta: {
            title: "原料集采平台-详情",
            roles: [],
            requireAuth: false
          }
        }
      ]
    },
    {
      path: "/new-tech",
      name: "NewTech",
      redirect: "/new-tech/files",
      component: resolve => require(["@/Views/NewTech"], resolve),
      meta: {
        title: "新技术应用平台",
        roles: [],
        requireAuth: false
      },
      children: [
        {
          path: "/new-tech/info",
          name: "NewTechInfo",
          component: resolve => require(["@/Views/NewTech/info"], resolve),
          meta: {
            title: "前沿资讯",
            roles: [],
            requireAuth: false
          }
        },
        {
          path: "/new-tech/base",
          name: "NewTechBase",
          component: resolve => require(["@/Views/NewTech/Base"], resolve),
          meta: {
            title: "新技术产品",
            roles: [],
            requireAuth: false
          }
        },
        {
          path: "/new-tech/requirement",
          name: "NewTechRequirement",
          component: resolve =>
            require(["@/Views/NewTech/Requirement"], resolve),
          meta: {
            title: "技术需求",
            roles: [],
            requireAuth: false
          }
        },
        {
          path: "/new-tech/files",
          name: "NewTechFiles",
          component: resolve => require(["@/Views/NewTech/Files"], resolve),
          meta: {
            title: "技术文件",
            roles: [],
            requireAuth: false
          }
        },
        {
          path: "/new-tech/detail/:id/:m_type",
          name: "NewTechInfoDetail",
          component: resolve => require(["@/Views/InfoDetail"], resolve),
          meta: {
            title: "新技术应用平台-详情",
            roles: [],
            requireAuth: false
          }
        }
      ]
    },
    {
      path: "/me",
      name: "ME",
      component: resolve => require(["@/Views/Me"], resolve),
      meta: {
        title: "我的",
        roles: [],
        requireAuth: false
      },
      children: [
        {
          path: "/me/service",
          name: "MeService",
          component: resolve => require(["@/Views/Me/Service"], resolve),
          meta: {
            title: "我的-咨询",
            roles: [],
            requireAuth: false
          }
        },
        {
          path: "/me/tech",
          name: "MeTech",
          component: resolve => require(["@/Views/Me/Tech"], resolve),
          meta: {
            title: "我的-文件",
            roles: [],
            requireAuth: false
          }
        },
        {
          path: "/me/lab",
          name: "MeLab",
          component: resolve => require(["@/Views/Me/Lab"], resolve),
          meta: {
            title: "我的-实验室资源",
            roles: [],
            requireAuth: false
          }
        },
        {
          path: "/me/product",
          name: "MeProduct",
          component: resolve => require(["@/Views/Me/Product"], resolve),
          meta: {
            title: "我的-产品",
            roles: [],
            requireAuth: false
          }
        },
        {
          path: "/me/material",
          name: "Mematerial",
          component: resolve => require(["@/Views/Me/Material"], resolve),
          meta: {
            title: "我的-需求",
            roles: [],
            requireAuth: false
          }
        },
        {
          path: "/me/docking",
          name: "MeDocking",
          component: resolve => require(["@/Views/Me/Docking"], resolve),
          meta: {
            title: "我的-商务对接",
            roles: [],
            requireAuth: false
          }
        },
        {
          path: "/me/info",
          name: "MeInfo",
          component: resolve => require(["@/Views/Me/Info"], resolve),
          meta: {
            title: "我的-个人信息",
            roles: [],
            requireAuth: false
          }
        },
        {
          path: "/me/forum",
          name: "MeForum",
          component: resolve => require(["@/Views/Me/Forum"], resolve),
          meta: {
            title: "我的-论坛",
            roles: [],
            requireAuth: false
          }
        },
        {
          path: "/me/policy",
          name: "MePolicy",
          component: resolve => require(["@/Views/Me/Policy"], resolve),
          meta: {
            title: "我的-政策申报",
            roles: [],
            requireAuth: false
          }
        }
      ]
    },
    {
      path: "/login",
      name: "Login",
      component: resolve => require(["@/Views/Login"], resolve),
      meta: {
        title: "登录",
        roles: [],
        requireAuth: false
      }
    },
    {
      path: "/register",
      name: "Register",
      component: resolve => require(["@/Views/Register"], resolve),
      meta: {
        title: "注册",
        roles: [],
        requireAuth: false
      }
    },
    {
      path: "/forum",
      name: "Forum",
      component: resolve => require(["@/Views/Forum"], resolve),
      meta: {
        title: "论坛",
        roles: [],
        requireAuth: false
      }
    },
    {
      path: "/forum/detail/:id",
      name: "ForumDetail",
      component: resolve => require(["@/Views/Forum/ForumDetail"], resolve),
      meta: {
        title: "论坛详情",
        roles: [],
        requireAuth: false
      }
    },
    {
      path: "/404",
      name: "404",
      component: resolve => require(["@/Views/ErrorPage/NotFound"], resolve),
      meta: {
        title: "页面不存在",
        requireAuth: false
      }
    },
    {
      path: "/403",
      name: "403",
      component: resolve => require(["@/Views/ErrorPage/LockedPage"], resolve),
      meta: {
        title: "无权限访问",
        requireAuth: false
      }
    },

    {
      path: "/admin",
      redirect: "/admin/dashboard",
      component: resolve => require(["@/Views/Admin/Layout"], resolve),
      children: [
        {
          path: "/admin/dashboard",
          name: "dashboard",
          component: resolve => require(["@/Views/Admin/Dashboard"], resolve),
          meta: {
            title: "控制台",
            roles: [],
            requireAuth: false,
            show: true
          }
        },
        {
          path: "/admin/release",
          name: "release",
          component: resolve => require(["@/Views/Admin/Release"], resolve),
          meta: {
            title: "我的发布",
            roles: ["1-1"],
            requireAuth: true,
            show: true,
            breadCrumb: [
              {
                name: "我的发布",
                path: "/admin/release"
              }
            ]
          }
        },
        {
          path: "/admin/release/add",
          name: "releaseAdd",
          component: resolve =>
            require(["@/Views/Admin/Release/AddEdit"], resolve),
          meta: {
            title: "添加发布",
            roles: ["1-2"],
            requireAuth: true,
            breadCrumb: [
              {
                name: "我的发布",
                path: "/admin/release"
              },
              {
                name: "添加发布",
                path: ""
              }
            ]
          }
        },
        {
          path: "/admin/release/edit/:id/:m_type",
          name: "releaseEdit",
          component: resolve =>
            require(["@/Views/Admin/Release/AddEdit"], resolve),
          meta: {
            title: "修改发布",
            roles: ["1-4"],
            requireAuth: true,
            breadCrumb: [
              {
                name: "我的发布",
                path: "/admin/release"
              },
              {
                name: "修改发布",
                path: ""
              }
            ]
          }
        },
        {
          path: "/admin/release/show/:id/:m_type",
          name: "releaseShow",
          component: resolve =>
            require(["@/Views/Admin/Release/AddEdit"], resolve),
          meta: {
            title: "查看发布",
            roles: ["1-5"],
            requireAuth: true,
            breadCrumb: [
              {
                name: "我的发布",
                path: "/admin/release"
              },
              {
                name: "查看发布",
                path: ""
              }
            ]
          }
        },
        {
          path: "/admin/userrelease",
          name: "userRelease",
          component: resolve => require(["@/Views/Admin/UserRelease"], resolve),
          meta: {
            title: "用户发布",
            roles: ["1-1"],
            requireAuth: true,
            show: true,
            breadCrumb: [
              {
                name: "用户发布",
                path: "/admin/release"
              }
            ]
          }
        },
        {
          path: "/admin/userrelease/add",
          name: "userreleaseAdd",
          component: resolve =>
            require(["@/Views/Admin/Release/AddEdit"], resolve),
          meta: {
            title: "添加发布",
            roles: ["1-2"],
            requireAuth: true,
            breadCrumb: [
              {
                name: "用户发布",
                path: "/admin/userrelease"
              },
              {
                name: "添加发布",
                path: ""
              }
            ]
          }
        },
        {
          path: "/admin/userrelease/edit/:id/:m_type",
          name: "userreleaseEdit",
          component: resolve =>
            require(["@/Views/Admin/Release/AddEdit"], resolve),
          meta: {
            title: "修改发布",
            roles: ["1-4"],
            requireAuth: true,
            breadCrumb: [
              {
                name: "用户发布",
                path: "/admin/userrelease"
              },
              {
                name: "修改发布",
                path: ""
              }
            ]
          }
        },
        {
          path: "/admin/userrelease/show/:id/:m_type",
          name: "userreleaseShow",
          component: resolve =>
            require(["@/Views/Admin/Release/AddEdit"], resolve),
          meta: {
            title: "查看发布",
            roles: ["1-5"],
            requireAuth: true,
            breadCrumb: [
              {
                name: "用户发布",
                path: "/admin/userrelease"
              },
              {
                name: "查看发布",
                path: ""
              }
            ]
          }
        },
        {
          path: "/admin/policy",
          name: "adminPolicy",
          component: resolve => require(["@/Views/Admin/Policy"], resolve),
          meta: {
            title: "政策申报",
            roles: ["11-1", "11-2", "11-3", "11-4", "11-5"],
            requireAuth: true,
            show: true
          },
          children: [
            {
              path: "/admin/policy/project",
              name: "adminProject",
              component: resolve =>
                require(["@/Views/Admin/Policy/Project"], resolve),
              meta: {
                title: "项目发布",
                roles: ["11-1"],
                requireAuth: true,
                show: true,
                breadCrumb: [
                  {
                    name: "政策申报",
                    path: ""
                  },
                  {
                    name: "项目发布",
                    path: "/admin/policy/project"
                  }
                ]
              }
            },
            {
              path: "/admin/policy/explain",
              name: "adminExplain",
              component: resolve =>
                require(["@/Views/Admin/Policy/Explain"], resolve),
              meta: {
                title: "政策解读",
                roles: ["11-2"],
                requireAuth: true,
                show: true,
                breadCrumb: [
                  {
                    name: "政策申报",
                    path: ""
                  },
                  {
                    name: "政策解读",
                    path: "/admin/policy/explain"
                  }
                ]
              }
            },
            {
              path: "/admin/policy/consulting",
              name: "adminConsulting",
              component: resolve =>
                require(["@/Views/Admin/Policy/Consulting"], resolve),
              meta: {
                title: "项目咨询",
                roles: ["11-3"],
                requireAuth: true,
                show: true,
                breadCrumb: [
                  {
                    name: "政策申报",
                    path: ""
                  },

                  {
                    name: "项目咨询",
                    path: "/admin/policy/consulting"
                  }
                ]
              }
            },
            {
              path: "/admin/policy/pretrial",
              name: "adminPretrial",
              component: resolve =>
                require(["@/Views/Admin/Policy/Pretrial"], resolve),
              meta: {
                title: "申报预审",
                roles: ["11-4"],
                requireAuth: true,
                show: true,
                breadCrumb: [
                  {
                    name: "政策申报",
                    path: ""
                  },
                  {
                    name: "申报预审",
                    path: "/admin/policy/pretrial"
                  }
                ]
              }
            },
            {
              path: "/admin/policy/archive",
              name: "adminArchive",
              component: resolve =>
                require(["@/Views/Admin/Policy/Archive"], resolve),
              meta: {
                title: "材料归档",
                roles: ["11-5"],
                requireAuth: true,
                show: true,
                breadCrumb: [
                  {
                    name: "政策申报",
                    path: ""
                  },
                  {
                    name: "材料归档",
                    path: "/admin/policy/archive"
                  }
                ]
              }
            },
            {
              path: "/admin/policy/archive/detail/:id/:name",
              name: "adminArchiveDetail",
              component: resolve =>
                require(["@/Views/Admin/Policy/ArchiveDetail"], resolve),
              meta: {
                title: "材料归档",
                roles: ["11-5"],
                requireAuth: true,
                show: false,
                breadCrumb: [
                  {
                    name: "政策申报",
                    path: ""
                  },
                  {
                    name: "材料归档",
                    path: "/admin/policy/archive"
                  }
                ]
              }
            },
            {
              path: "/admin/policy/projectAdd",
              name: "adminProjectAdd",
              component: resolve =>
                require(["@/Views/Admin/Policy/AddEdit"], resolve),
              meta: {
                title: "发布项目",
                roles: ["11-1", "11-2", "11-3", "11-4", "11-5"],
                requireAuth: true,
                show: false,
                breadCrumb: [
                  {
                    name: "政策申报",
                    path: ""
                  },
                  {
                    name: "项目发布",
                    path: "/admin/policy/project"
                  }
                ]
              }
            },
            {
              path: "/admin/policy/projectEdit/:id",
              name: "adminProjectEdit",
              component: resolve =>
                require(["@/Views/Admin/Policy/AddEdit"], resolve),
              meta: {
                title: "编辑项目",
                roles: ["11-1", "11-2", "11-3", "11-4", "11-5"],
                requireAuth: true,
                show: false,
                breadCrumb: [
                  {
                    name: "政策申报",
                    path: ""
                  },
                  {
                    name: "项目发布",
                    path: "/admin/policy/project"
                  }
                ]
              }
            },
            {
              path: "/admin/policy/projectShow/:id",
              name: "adminProjectShow",
              component: resolve =>
                require(["@/Views/Admin/Policy/AddEdit"], resolve),
              meta: {
                title: "查看项目",
                roles: ["11-1", "11-2", "11-3", "11-4", "11-5"],
                requireAuth: true,
                show: false,
                breadCrumb: [
                  {
                    name: "政策申报",
                    path: ""
                  },
                  {
                    name: "项目发布",
                    path: "/admin/policy/project"
                  }
                ]
              }
            },
            {
              path: "/admin/policy/explainAdd",
              name: "adminExplainAdd",
              component: resolve =>
                require(["@/Views/Admin/Policy/ExplainAddEdit"], resolve),
              meta: {
                title: "政策解读",
                roles: ["11-2"],
                requireAuth: true,
                show: false,
                breadCrumb: [
                  {
                    name: "政策申报",
                    path: ""
                  },
                  {
                    name: "政策解读",
                    path: "/admin/policy/explain"
                  }
                ]
              }
            },
            {
              path: "/admin/policy/explainEdit/:id",
              name: "adminExplainEdit",
              component: resolve =>
                require(["@/Views/Admin/Policy/ExplainAddEdit"], resolve),
              meta: {
                title: "政策解读",
                roles: ["11-2"],
                requireAuth: true,
                show: false,
                breadCrumb: [
                  {
                    name: "政策申报",
                    path: ""
                  },
                  {
                    name: "政策解读",
                    path: "/admin/policy/explain"
                  }
                ]
              }
            },
            {
              path: "/admin/policy/explainShow/:id",
              name: "adminExplainShow",
              component: resolve =>
                require(["@/Views/Admin/Policy/ExplainAddEdit"], resolve),
              meta: {
                title: "政策解读",
                roles: ["11-2"],
                requireAuth: true,
                show: false,
                breadCrumb: [
                  {
                    name: "政策申报",
                    path: ""
                  },
                  {
                    name: "政策解读",
                    path: "/admin/policy/explain"
                  }
                ]
              }
            }
          ]
        },
        {
          path: "/admin/analyze",
          name: "adminAnalyze",
          component: resolve => require(["@/Views/Admin/Analyze"], resolve),
          meta: {
            title: "统计分析",
            roles: ["6-1", "6-2"],
            requireAuth: true,
            show: true
          },
          children: [
            {
              path: "/admin/analyze/purchase",
              name: "Purchase",
              component: resolve =>
                require(["@/Views/Admin/Analyze/Purchase"], resolve),
              meta: {
                title: "采购计划分析",
                roles: ["6-1"],
                show: true,
                requireAuth: true,
                breadCrumb: [
                  {
                    name: "统计分析",
                    path: ""
                  },
                  {
                    name: "采购计划分析",
                    path: ""
                  }
                ]
              }
            },
            {
              path: "/admin/analyze/forum",
              name: "analyzeForum",
              component: resolve =>
                require(["@/Views/Admin/Analyze/Forum"], resolve),
              meta: {
                title: "论坛统计",
                roles: ["6-2"],
                show: true,
                requireAuth: true,
                breadCrumb: [
                  {
                    name: "统计分析",
                    path: ""
                  },
                  {
                    name: "论坛统计",
                    path: ""
                  }
                ]
              }
            }
          ]
        },
        {
          path: "/admin/forum",
          name: "adminForum",
          redirect: "/admin/forum/type",
          component: resolve => require(["@/Views/Admin/Forum"], resolve),
          meta: {
            title: "论坛管理",
            roles: ["3-1"],
            requireAuth: true,
            show: true,
            breadCrumb: [
              {
                name: "论坛管理",
                path: ""
              }
            ]
          },
          children: [
            {
              path: "/admin/forum/specialist",
              name: "specialist",
              component: resolve => require(["@/Views/Admin/Specialist"], resolve),
              meta: {
                title: "专家管理",
                roles: ["4-1"],
                requireAuth: true,
                show: true,
                breadCrumb: [
                  {
                    name: "专家管理",
                    path: ""
                  }
                ]
              }
            },
            {
              path: "/admin/forum/type",
              name: "forumType",
              component: resolve =>
                require(["@/Views/Admin/Forum/type"], resolve),
              meta: {
                title: "板块管理",
                roles: ["3-1"],
                show: true,
                requireAuth: true,
                breadCrumb: [
                  {
                    name: "论坛管理",
                    path: ""
                  },
                  {
                    name: "板块管理",
                    path: ""
                  }
                ]
              }
            },
            {
              path: "/admin/forum/topic",
              name: "forumTopic",
              component: resolve =>
                require(["@/Views/Admin/Forum/topic"], resolve),
              meta: {
                title: "帖子管理",
                roles: ["3-1"],
                show: true,
                requireAuth: true,
                breadCrumb: [
                  {
                    name: "论坛管理",
                    path: ""
                  },
                  {
                    name: "帖子管理",
                    path: ""
                  }
                ]
              }
            }
          ]
        },
        {
          path: "/admin/system",
          name: "system",
          redirect: "/admin/system/user-management",
          component: resolve => require(["@/Views/Admin/System"], resolve),
          meta: {
            title: "系统设置",
            roles: ["8-1", "7-1", "9-1", "10-1", "10-2"],
            requireAuth: true,
            show: true,
            breadCrumb: [
              {
                name: "系统设置",
                path: ""
              }
            ]
          },
          children: [
            {
              path: "/admin/system/user-management",
              name: "userManagement",
              component: resolve =>
                require(["@/Views/Admin/System/UserManagement"], resolve),
              meta: {
                title: "用户管理",
                roles: ["8-1"],
                show: true,
                requireAuth: true,
                breadCrumb: [
                  {
                    name: "系统设置",
                    path: ""
                  },
                  {
                    name: "用户管理",
                    path: ""
                  }
                ]
              }
            },
            {
              path: "/admin/system/role-management",
              name: "roleManagement",
              component: resolve =>
                require(["@/Views/Admin/System/RoleManagement"], resolve),
              meta: {
                title: "角色管理",
                roles: ["7-1"],
                show: true,
                requireAuth: true,
                breadCrumb: [
                  {
                    name: "系统设置",
                    path: ""
                  },
                  {
                    name: "角色管理",
                    path: ""
                  }
                ]
              }
            },
            {
              path: "/admin/system/organizational-management",
              name: "organizationalManagement",
              component: resolve =>
                require(["@/Views/Admin/System/Organization"], resolve),
              meta: {
                title: "机构管理",
                roles: ["9-1"],
                requireAuth: true,
                show: true,
                breadCrumb: [
                  {
                    name: "系统设置",
                    path: ""
                  },
                  {
                    name: "机构管理",
                    path: ""
                  }
                ]
              }
            },
            {
              path: "/admin/system/banner-management",
              name: "bannerManagement",
              component: resolve =>
                require(["@/Views/Admin/System/BannerManagement"], resolve),
              meta: {
                title: "轮播图管理",
                roles: ["10-1"],
                requireAuth: true,
                show: true,
                breadCrumb: [
                  {
                    name: "系统设置",
                    path: ""
                  },
                  {
                    name: "轮播图管理",
                    path: ""
                  }
                ]
              }
            },
            {
              path: "/admin/system/record-management",
              name: "recordManagement",
              component: resolve =>
                require(["@/Views/Admin/System/RecordManagement"], resolve),
              meta: {
                title: "操作日志",
                roles: ["10-2"],
                requireAuth: true,
                show: true,
                breadCrumb: [
                  {
                    name: "系统设置",
                    path: ""
                  },
                  {
                    name: "操作日志",
                    path: ""
                  }
                ]
              }
            }
          ]
        }
      ]
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js